export enum CargoTempLogStatusEnum {
    configMissing = 1,
    incomplete = 2,
    complete = 3,
    noCargo = 4,
}